import EE from '~/listenerEventService/EventEmitter';
import MutationObserver from '~/utils/MutationObserver';
import settings from '~/utils/Settings';

export default class DomListener extends EE {
  constructor() {
    super();
    this.observer = new MutationObserver(this.observerCallback.bind(this));

    this.containers = [];

    const observableNodes = document.evaluate(
      this.domObservableXPath,
      document,
      null,
      XPathResult.ORDERED_NODE_ITERATOR_TYPE,
      null
    );

    let container = observableNodes.iterateNext();
    while (container) {
      this.containers.push(container);
      container = observableNodes.iterateNext();
    }
  }

  get domObservableXPath() {
    return settings.getOrDefault('DOM_OBSERVABLE_XPATH', '/html');
  }

  start() {
    for (const container of this.containers) {
      this.observer.observe(container);
    }
  }

  stop() {
    this.observer.disconnect();
  }

  observerCallback(eventMutation) {
    switch (eventMutation.type) {
      case 'childList': {
        const isChildListAddEventType = eventMutation.addedNodes.length > 0;
        const nodes = Array.prototype.slice.call(
          isChildListAddEventType
            ? eventMutation.addedNodes
            : eventMutation.removedNodes
        );
        this.emit('analytics', {
          type: isChildListAddEventType ? 'add-child' : 'remove-child',
          nodes,
          save: false,
        });
        break;
      }
      case 'attributes': {
        const { target, attributeName, attributeOldValue } = eventMutation;
        this.emit('analytics', {
          type: 'attribute-change',
          target,
          attributeName,
          attributeOldValue,
          save: false,
        });
        break;
      }
    }
  }
}
